/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface UmbrellaInvitedEventTimelinePayload
 */
export interface UmbrellaInvitedEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaInvitedEventTimelinePayload
     */
    umbrellaCompanyEmail: string;
}

/**
 * Check if a given object implements the UmbrellaInvitedEventTimelinePayload interface.
 */
export function instanceOfUmbrellaInvitedEventTimelinePayload(value: object): value is UmbrellaInvitedEventTimelinePayload {
    if (!('umbrellaCompanyEmail' in value) || value['umbrellaCompanyEmail'] === undefined) return false;
    return true;
}

export function UmbrellaInvitedEventTimelinePayloadFromJSON(json: any): UmbrellaInvitedEventTimelinePayload {
    return UmbrellaInvitedEventTimelinePayloadFromJSONTyped(json, false);
}

export function UmbrellaInvitedEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaInvitedEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'umbrellaCompanyEmail': json['umbrellaCompanyEmail'],
    };
}

export function UmbrellaInvitedEventTimelinePayloadToJSON(value?: UmbrellaInvitedEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'umbrellaCompanyEmail': value['umbrellaCompanyEmail'],
    };
}

